import ShortFacts from './ShortFacts';

export default ShortFacts;
